const TOGGLE_CLASS_GROUP_ATTR = 'data-toggle-class-group';
const TOGGLE_CLASS_TRIGGER_ATTR = 'data-toggle-class-trigger';
const TOGGLE_CLASS_ACTIVE_ATTR = 'data-toggle-class-active';
const TOGGLE_CLASS_REMOVE_ACTIVE_GROUP_ATTR = 'data-toggle-class-remove-active-group';

const TOGGLE_CLASS_GROUP_SELECTOR = '[' + TOGGLE_CLASS_GROUP_ATTR + ']';
const TOGGLE_CLASS_TRIGGER_SELECTOR = '[' + TOGGLE_CLASS_TRIGGER_ATTR + ']';

/**
 * Generic solution that toggles active classes on elements when a trigger elements get clicked
 * The elements are grouped. 
 */

/*
<button
    data-toggle-class-group="main-menu"         // Group id
    data-toggle-class-trigger                   // Trigger marker
    data-toggle-class-active="button-active"    // Active class to toggle
>
    Menu
</button>
[....]
<div 
    class="main-menu"
    data-toggle-class-group="main-menu"             // Group id
    data-toggle-class-active="main-menu--active"    // Active class to toggle
>
    [..]
</div>
*/


function closest(child, selector) {
    if (!child || !child.matches) {
        return null;
    }

    if (child.matches(selector)) {
        return child;
    }

    return closest(child.parentNode, selector);
}

export default class ClassToggler {
    constructor() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        document.addEventListener('click', (e) => {
            const clickTarget = e.target;
            let toggleGroup = closest(clickTarget, TOGGLE_CLASS_GROUP_SELECTOR + TOGGLE_CLASS_TRIGGER_SELECTOR);

            if (toggleGroup) {
                const groupId = toggleGroup.getAttribute(TOGGLE_CLASS_GROUP_ATTR);
                const groupElementsSelector = '[' + TOGGLE_CLASS_GROUP_ATTR + '="' + groupId + '"]';
                const groupElements = document.querySelectorAll(groupElementsSelector);
                const removeActiveGroupIds = toggleGroup.getAttribute(TOGGLE_CLASS_REMOVE_ACTIVE_GROUP_ATTR);

                if (removeActiveGroupIds && removeActiveGroupIds.length) {
                    removeActiveGroupIds.split(',').forEach((groupId) => {
                        this.removeActiveGroupClass(groupId.trim());
                    });
                }

                groupElements.forEach((groupElement) => {
                    this.toggleActiveClass(groupElement);
                });
            }
        });
    }

    removeActiveGroupClass(groupId) {
        const groupElementsSelector = '[' + TOGGLE_CLASS_GROUP_ATTR + '="' + groupId + '"]';
        const groupElements = document.querySelectorAll(groupElementsSelector);

        groupElements.forEach((groupElement) => {
            this.removeActiveClass(groupElement);
        });
    }

    removeActiveClass(element) {
        const activeClass = element.getAttribute(TOGGLE_CLASS_ACTIVE_ATTR);
        
        if (!activeClass) {
            return;
        }

        if (element.matches('.' + activeClass)) {
            element.classList.remove(activeClass);
        }
    }

    toggleActiveClass(element) {
        const activeClass = element.getAttribute(TOGGLE_CLASS_ACTIVE_ATTR);
        
        if (!activeClass) {
            return;
        }

        if (element.matches('.' + activeClass)) {
            element.classList.remove(activeClass);
        } else {
            element.classList.add(activeClass);
        }
    }

}